import { toaster } from "@itwin/itwinui-react"
import { isRejectedWithValue } from "@reduxjs/toolkit"
import { Middleware, MiddlewareAPI } from "redux"

export const rtkQueryErrorLogger: Middleware =
  (_api: MiddlewareAPI) => (next) => (action) => {
    // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
    if (isRejectedWithValue(action)) {

      // NOTE: validation errors must be handled by components
      if (action.payload.data.status === 400)
        return next(action);

      const genericMessage = parseGenericErrorResult(action.payload.data);
      if (genericMessage) displayNegativeToast(genericMessage);

      if (!genericMessage) {
        // if (action.payload.status === 404)
        //   displayNegativeToast("Not Found");
        if (action.payload.status === 401)
          displayNegativeToast("Unauthorized");
        else if (action.payload.status >= 500)
          displayNegativeToast(`[${action.payload.status}] ${JSON.stringify(action.payload.data)}`)
      }
    }

    return next(action);
  }

const displayNegativeToast = (content: string) => {
  toaster.setSettings({
    placement: "top",
    order: "descending",
  });
  toaster.negative(content, {
    hasCloseButton: true,
  });
};

// const parseValidationProblemDetailsError = (data: any) => {
//   const messages: string[] = [];
//   if (data.title && data.status && data.errors) {
//     if (data.status === 400 && data.title === "One or more validation errors occurred.") {
//       for (const field of Object.keys(data.errors)) {
//         for (const error of data.errors[field]) {
//           messages.push(`[${field}] ${error}`);
//         }
//       }
//     }
//     return messages.join("\n");
//   }
//   return undefined;
// };

const parseGenericErrorResult = (data: any) => {
  if (data.errorMessage)
    return data.errorMessage;
};
